import { render, staticRenderFns } from "./CompensationTable.vue?vue&type=template&id=6fb7bab5&scoped=true&"
import script from "./CompensationTable.vue?vue&type=script&lang=js&"
export * from "./CompensationTable.vue?vue&type=script&lang=js&"
import style0 from "./CompensationTable.vue?vue&type=style&index=0&id=6fb7bab5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7bab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VProgressLinear,VSimpleTable,VSpacer,VToolbar,VTooltip})
